<template>
  <v-card width="100%" height="100vh" elevation="0">
    <v-container fill-height color="white">
      <v-row justify="center" align="center">
        <v-col cols="12" justify="center" align="center">
          <v-progress-circular
            :width="5"
            :size="50"
            color="primary"
            indeterminate
          />
        </v-col>
        <v-col cols="12" justify="center" align="center">
          Obteniendo filtros ...
        </v-col>
      </v-row>
    </v-container>
  </v-card>
</template>

<script>
export default { name: "LoadingFilters" };
</script>
